import { useTranslation } from 'react-i18next';

import { PlanSection } from '~/modules/artist-roster/pages/artist-details/pages/media-planner/components/PlanWizard/components/PlanSection';

export function FrequencyCapSection() {
  const { t } = useTranslation('campaign-planner', {
    keyPrefix: 'digitalCampaigns',
  });

  return (
    <PlanSection
      title={t('planWizard.sections.frequencyCap.title')}
      description={t('planWizard.sections.frequencyCap.description')}
    >
      {/* eslint-disable-next-line i18next/no-literal-string */}
      <p>@TODO WMG1-658 - Frequency Cap</p>
    </PlanSection>
  );
}

FrequencyCapSection.displayName = 'FrequencyCapSection';
